import React, { useState } from "react";
import { Plus, Minus, Phone } from "lucide-react";
import { telHref } from "../lib/config";
import { trackCall, trackEvent } from "../lib/analytics";

export default function FAQ({ lang, T }) {
  const items = T.faq.items[lang];
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-16 md:py-24 bg-ink-800/40">
      <div className="mx-auto max-w-7xl px-4 md:px-6 grid lg:grid-cols-12 gap-10 items-start">
        <div className="lg:col-span-5 reveal">
          <span className="chip mb-3">FAQ</span>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight">{T.faq.h2[lang]}</h2>
          <p className="mt-4 text-muted max-w-md">
            {lang === "uz"
              ? "Eng tez yo'l — qo'ng'iroq. Menejer 1 daqiqada javob beradi."
              : "Самый быстрый способ — звонок. Менеджер ответит за 1 минуту."}
          </p>
          <a
            href={telHref}
            onClick={() => trackCall("faq")}
            data-testid="faq-call-button"
            className="cta-pulse mt-6 inline-flex items-center gap-2 btn-call rounded-full px-6 py-3.5 text-base shadow-flame"
          >
            <Phone size={18} strokeWidth={2.6} /> {T.cta.callManager[lang]}
          </a>
          <div className="hidden lg:block mt-8 relative rounded-[28px] overflow-hidden glass">
            <img src="/images/aircooler/4.png" alt="" loading="lazy" className="w-full h-60 object-cover" />
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="space-y-3">
            {items.map(([q, a], i) => (
              <div
                key={i}
                className="rounded-2xl border border-white/8 bg-ink-500/70 overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  onClick={() => {
                    const nxt = open === i ? -1 : i;
                    setOpen(nxt);
                    if (nxt === i) trackEvent("FAQOpen", { index: i, language: lang });
                  }}
                  data-testid={`faq-toggle-${i}`}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-white font-semibold text-[15px] md:text-base">{q}</span>
                  <span className="w-9 h-9 rounded-full grid place-items-center bg-white/5 text-ice-300 shrink-0">
                    {open === i ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                {open === i && (
                  <div className="px-5 pb-5 text-muted text-sm leading-relaxed">{a}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
